<template>
    <div class="analysisDetail-container">
        <headline :params="headLines" />
        <div class="content-container">
            <div class="left-container">
                <!-- <div @click="navigateBack" class="top">
                    <i></i>
                    <span>返回搜索</span>
                </div> -->
                <div class="content">
                    <div class="top-container">
                        <p :title="detail.title" class="title">{{detail.minTitle}}</p>
                        <div class="info">
                            <span v-if="detail.type">渠道：{{detail.type}}</span>
                            <span v-if="detail.client_name">来源：{{detail.client_name}}</span>
                            <span v-if="detail.author">作者：{{detail.author}}</span>
                            <span v-if="detail.time">发布时间: {{detail.time}}</span>
                        </div>
                        <p v-if="detail.url" @click="navigate(detail.url)" class="link">
                            <i></i>
                            <span>查看原文</span>
                        </p>
                    </div>

                    <div class="middle-container">
                        <div v-if="false" class="info">芥末堆文 据陕西日报，陕西省教育厅厅长刘建林近日表示，陕西将于2022年启动高考综合改革，在普通高中同步实施新课程新教材，2025年全面实施新高考。</div>
                        <div class="article">{{detail.content}}</div>
                    </div>
                </div>
            </div>
            <div class="right-container">
                <div class="title">传播力分析报告</div>
                <div class="tips">"<span class="t">{{detail.title}}</span>"报道，在互联网上共载媒体之数<span>{{chartDetail.total}}</span>次。传播力指数为<span>{{chartDetail.trans_power}}</span><i><p><i class="arrow"></i>传播力指数基于媒体转载</p></i></div>
                <div class="chart1">
                    <div class="left">
                        <div class="top">传播力指数及传播途径</div>
                        <div ref="chart1Bottom" class="bottom"></div>
                    </div>
                    <div ref="chart1Right" class="right"></div>
                </div>
                <div v-show="chartDetail.total - 0 > 0" class="title">媒体传播比例</div>
                <div v-show="chartDetail.total - 0 > 0" ref="chart2" class="chart2"></div>
                <div class="tab-list">
                    <ul>
                        <li @click="tabIndex = 'mainMediaShare'" :class="{on: tabIndex == 'mainMediaShare'}">重点</li>
                        <li @click="tabIndex = 'yangMediaShare'" :class="{on: tabIndex == 'yangMediaShare'}">中央级</li>
                        <li @click="tabIndex = 'shenMediaShare'" :class="{on: tabIndex == 'shenMediaShare'}">省级</li>
                        <li @click="tabIndex = 'weiboShare'" :class="{on: tabIndex == 'weiboShare'}">微博</li>
                        <li @click="tabIndex = 'weixinShare'" :class="{on: tabIndex == 'weixinShare'}">微信</li>
                        <li @click="tabIndex = 'appShare'" :class="{on: tabIndex == 'appShare'}">客户端</li>
                        <li @click="tabIndex = 'otherShare'" :class="{on: tabIndex == 'otherShare'}">其他</li>
                    </ul>
                </div>

                <ul class="tabs">
                    <li v-for="item in chartDetail && chartDetail[tabIndex]" :key="item.source">{{item.source}}
                        <div class="list">
                            <span></span>
                            <div class="icon"><i></i></div>
                            <div class="word-list">
                                <ul>
                                    <li @click="navigate(items.url)" v-for="items in item.list" :key="items.title">{{items.title}}</li>
                                </ul>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import pages from '@components/pages'
import common from '@common/common'
import { apis } from '@common/config'
import headline from "@components/headline";
import * as echarts from 'echarts';

export default {
    components: {
        pages, headline
    },
    data() {
        return {
            tabIndex: 'mainMediaShare',
            headLines: {
                title: "",
                showLink: false,
                filter: false
            },
            detail: {

            },
            chartDetail: {

            }
        }
    },
    methods: {
        getChart() {
            let info = {
                id: this.$route.query.d
            }

            common.myFetch(apis.cas, info).then(res => {
                console.log(res)
                this.chartDetail = res.detail
                this.$nextTick(() => {
                    this.getLeftChart(res.detail.trans_power)
                    this.getRightChart(res.detail.router)
                    this.getBottomChart(res.detail)
                })
            })
        },
        navigateBack() {
            common.jump('/analysisList', false)
        },
        navigate(url) {
            common.jumpOut(url)
        },
        getDetail(id) {
            let info = {
                id: id
            }

            common.myFetch(apis.analysisDetail, info).then(res => {
                if(res){
                    if(res.detail.title.length > 46){
                        res.detail.minTitle = res.detail.title.substring(0,43)+'...'
                    }else{
                        res.detail.minTitle = res.detail.title
                    }
                    this.detail = res.detail
                    console.log(res)
                }
            })
        },
        getLeftChart(value) {
            var chartDom = this.$refs.chart1Bottom;
            var myChart = echarts.init(chartDom);
            var option;

            option = {
                series: [
                    {
                        type: 'gauge',
                        min: 0,
                        max: 100,
                        splitNumber: 5,
                        axisLine: {
                            lineStyle: {
                            width: 15,
                                color: [
                                    [0.3, '#67e0e3'],
                                    [0.7, '#37a2da'],
                                    [1, '#fd666d']
                                ]
                            }
                        },
                        pointer: {
                            itemStyle: {
                                color: 'auto'
                            }
                        },
                        axisTick: {
                            distance: -30,
                            length: 8,
                            lineStyle: {
                                color: '#fff',
                                width: 2
                            }
                        },
                        splitLine: {
                            distance: 0,
                            length: 15,
                            lineStyle: {
                                color: '#fff',
                                width: 3
                            }
                        },
                        axisLabel: {
                            color: 'auto',
                            distance: 5,
                            fontSize: 10
                        },
                        detail: {
                            valueAnimation: true,
                            formatter: '{value}',
                            color: 'auto',
                            fontSize: 10
                        },
                        data: [
                            {
                                value: value
                            }
                        ]
                    }
                ]
            };
            myChart.setOption(option);
        },
        getRightChart(router) {
            // return false;
            var chartDom = this.$refs.chart1Right;
            var myChart = echarts.init(chartDom);
            var option;
            let arr = []

            router.categories.forEach(res => {
                arr.push(res.name)
            })

            option = {
                // legend: {
                //     data: arr
                // },
                color: ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452'],
                textStyle: {
                    color: '#000',
                    textBorderColor: '#FFF'
                },
                series: [
                {
                    type: 'graph',
                    layout: 'force',
                    animation: false,
                    label: {
                        position: 'right',
                        formatter: '{b}'
                    },
                    draggable: true,
                    data: router.nodes.map(function (node, idx) {
                        node.id = idx;
                        return node;
                    }),
                    categories: router.categories,
                    force: {
                        edgeLength: 5,
                        repulsion: 20,
                        gravity: 0.2
                    },
                    edges: router.links
                }
                ]
            };
            myChart.setOption(option);
        },
        getBottomChart(detail) {
            var chartDom = this.$refs.chart2;
            var myChart = echarts.init(chartDom);
            var option;
            let arr = []

            arr.push({
                name: '重点媒体',
                value: detail.mainNum
            })

            arr.push({
                name: '中央媒体',
                value: detail.yangNum
            })

            arr.push({
                name: '省级媒体',
                value: detail.shenNum
            })

            arr.push({
                name: '其他媒体',
                value: detail.otherNum
            })

            option = {
                color: ['#5B8FF9', '#9AAFD9', '#D9E2F4', '#A4C1FF', '#73c0de', '#3ba272', '#fc8452', '#9a60b41', '#ea7ccc'],
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'vertical',  //垂直显示
                    y: 'center',    //延Y轴居中
                    x: '75%'
                },
                series: [
                    {
                        name: '媒体传播比例',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: '12',
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: arr
                    }
                ]
            };

            option && myChart.setOption(option);
        }
    },
    mounted() {
        this.getChart()
    },
    created() {
        this.headLines.title = '内容传播力分析'
        let id = this.$route.query.d;
        this.getDetail(id)
    }
}
</script>

<style lang="less" scoped>
    .analysisDetail-container {
        .content-container {
            display: flex;
            flex-direction: row;
            justify-content: center;
            // overflow: hidden;
            overflow-y: auto;

            .left-container {
                display: flex;
                flex-direction: column;
                width: 576px;
                height: fit-content;
                // height: calc(100vh - 70px);
                margin-right: 20px;

                .top {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    width: 100%;
                    height: 60px;
                    user-select: none;
                    cursor: pointer;

                    i {
                        display: block;
                        width: 16px;
                        height: 16px;
                        background: url('../../assets/img/analysis/miniBack.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                        margin-right: 2px;
                    }

                    span {
                        font-size: 14px;
                        line-height: 16px;
                        color: #050F0F;
                        font-weight: bold;
                    }
                }

                .content {
                    width: 100%;
                    // height: calc(100% - 60px);              
                    background: #FFFFFF;              
                    border-radius: 2px 2px 0 0;
                    padding: 40px 40px;
                    box-sizing: border-box;
                    overflow-y: auto;

                    &::-webkit-scrollbar {
                        width: 4px;
                        height: 0;
                    }
                    &::-webkit-scrollbar-thumb {
                        // background: rgba(5, 15, 15, 0.6);
                        background: rgba(185, 195, 195, 0.5);
                        border-radius: 6px;
                    }

                    .top-container {
                        padding-bottom: 10px;
                        border-bottom: 1px solid #DCDCDC;
                        box-sizing: border-box;
                        margin-bottom: 13px;

                        .title {
                            font-size: 20px;
                            line-height: 30px;
                            font-weight: bold;
                            color: #050F0F;
                            margin-bottom: 10px;
                        }

                        .info {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            flex-wrap: wrap !important;

                            span {
                                display: block;
                                font-size: 12px;
                                line-height: 17px;
                                color: #829191;
                                font-weight: bold;
                                margin-right: 24px;
                                margin-bottom: 10px;

                                &:nth-last-of-type(1) {
                                    margin-right: 0;
                                }
                            }
                        }

                        .link {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            user-select: none;
                            cursor: pointer;

                            i {
                                display: block;
                                width: 20px;
                                height: 20px;
                                background: url('../../assets/img/analysis/link.png') no-repeat;
                                background-position: center center;
                                background-size: 100% 100%;
                                margin-right: 4px;
                            }

                            span {
                                font-size: 14px;
                                line-height: 20px;
                                color: #41B48C;
                                font-weight: bold;
                            }
                        }
                    }

                    .middle-container {
                        display: flex;
                        flex-direction: column;

                        .info {
                            padding: 14px;
                            box-sizing: border-box;
                            background: #F9F9F9;
                            border-radius: 4px;
                            font-size: 14px;
                            line-height: 21px;
                            color: #829191;
                            margin-bottom: 14px;
                        }

                        .article {
                            font-size: 16px;
                            line-height: 28px;
                            color: #050F0F;
                        }
                    }

                }
            }

            .right-container {
                display: flex;
                flex-direction: column;
                width: 698px;
                height: fit-content;
                // height: calc(100vh - 70px);          
                background: #FAFBFC;
                padding: 30px 37px;
                box-sizing: border-box;
                // overflow-y: auto;
                // overflow-x: hidden;

                .title {
                    position: relative;
                    padding-left: 19px;
                    padding-bottom: 16px;
                    border-bottom: 1px solid #DCDCDC;
                    box-sizing: border-box;
                    margin-bottom: 13px;
                    font-weight: bold;
                    font-size: 20px;
                    line-height: 28px;
                    color: #050F0F;

                    &:after {
                        position: absolute;
                        top: 50%;
                        left: 0;
                        margin-top: -12px;
                        display: block;
                        content: '';
                        width: 9px;
                        height: 9px;
                        background: #41B48C;
                        border-radius: 50%;
                    }
                }

                .tips {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    font-size: 14px;
                    line-height: 20px;
                    color: #050F0F;
                    margin-bottom: 13px;

                    span {
                        color: #41B48C;
                        font-weight: bold;

                        &.t {
                            display: block;
                            max-width: 180px;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                    }

                    i {
                        position: relative;
                        display: block;
                        width: 16px;
                        height: 16px;
                        background: url('../../assets/img/analysis/tips.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                        margin-left: 10px;

                        &:hover {
                            & > p {
                                display: flex;
                            }
                        }

                        p {
                            position: absolute;
                            bottom: 30px;
                            right: -20px;
                            display: none;
                            justify-content: center;
                            align-items: center;
                            width: 180px;
                            padding: 5px 12px;
                            box-sizing: border-box;
                            background: rgba(30,39,34,0.89);
                            font-size: 12px;
                            line-height: 21px;
                            color: #FFFFFF;
                            border-radius: 4px;

                            .arrow {
                                position: absolute;
                                right: 20px;
                                bottom: -9px;
                                display: block;
                                width: 16px;
                                height: 9px;
                                background: url('../../assets/img/analysis/miniAngle.png') no-repeat;
                                background-position: center center;
                                background-size: 100% 100%;
                            }
                        }
                    }
                }

                .chart1 {
                    display: flex;
                    flex-direction: row;
                    width: 624px;
                    min-height: 252px;
                    background: rgba(185, 195, 195, 0.1);
                    margin-bottom: 30px;

                    .left {
                        display: flex;
                        flex-direction: column;
                        width: 252px;
                        height: 252px;
                        border-right: 1px solid #DCDCDC;
                        box-sizing: border-box;

                        .top {
                            line-height: 50px;
                            width: 100%;
                            height: 50px;
                            border-bottom: 1px solid #DCDCDC;
                            box-sizing: border-box;
                            padding: 0 10px;
                            box-sizing: border-box;
                            font-size: 16px;
                        }

                        .bottom {
                            width: 100%;
                            height: 202px;
                        }
                    }

                    .right {
                        flex: 1;
                        height: 252px;
                    }
                }

                .chart2 {
                    width: 624px;
                    min-height: 234px;
                    // background: rgba(185, 195, 195, 0.1);
                    margin-bottom: 50px;
                }

                .tab-list {
                    width: 100%;
                    height: 22px;

                    ul {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        width: 100%;
                        padding-bottom: 14px;
                        border-bottom: 1px solid #DCDCDC;
                        box-sizing: border-box;

                        li {
                            position: relative;
                            width: 64px;
                            height: 22px;
                            line-height: 22px;
                            text-align: center;
                            font-size: 16px;
                            color: #050F0F;
                            font-weight: bold;
                            user-select: none;
                            cursor: pointer;

                            &.on {
                                color: #41B48C;

                                &:after {
                                    display: block;
                                    content: '';
                                    position: absolute;
                                    bottom: -15px;
                                    width: 64px;
                                    height: 2px;
                                    background-color: #41B48C;
                                }
                            }
                        }
                    }
                }

                .tabs {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    flex-wrap: wrap;
                    margin-top: 34px;

                    & > li {
                        position: relative;
                        height: 24px;
                        padding: 0 14px;
                        box-sizing: border-box;
                        font-size: 13px;
                        line-height: 24px;
                        color: #323B4B;
                        background: rgba(185,195,195,0.2);
                        margin: 0 10px 10px 0;
                        cursor: pointer;

                        &:hover {
                            .list {
                                display: flex;
                            }
                        }

                        .list {
                            position: absolute;
                            top: 24px;
                            left: 50%;
                            z-index: 9;
                            margin-left: -50%;
                            display: none;
                            flex-direction: column;
                            align-items: center;
                            width: 100%;
                            & > span {
                                width: 100%;
                                height: 6px;
                            }

                            .icon {
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                width: 100%;

                                i {
                                    width: 16px;
                                    height: 9px;
                                    background: url('../../assets/img/analysis/miniAngle.png') no-repeat;
                                    background-position: center center;
                                    background-size: 100% 100%;
                                    transform: rotate(180deg);
                                }
                            }

                            .word-list {
                                width: 340px;
                                background: rgba(5,15,15,0.8);
                                box-sizing: border-box;
                                border-radius: 4px;
                                padding: 10px 0;

                                ul {
                                    display: flex;
                                    flex-direction: column;
                                    width: 100%;

                                    li {
                                        width: 100%;
                                        height: 30px;
                                        line-height: 30px;
                                        padding: 0 20px;
                                        font-size: 14px;
                                        color: #FFFFFF;
                                        overflow: hidden;
                                        white-space: nowrap;
                                        text-overflow: ellipsis;
                                        box-sizing: border-box;

                                        &:hover { 
                                            background: rgba(255, 255, 255, 0.1);
                                            color: #41B48C;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>